import React, { useCallback } from 'react'

import { hooks } from '@front/volcanion'

import Component from './component'

const Container = () => {
  const requestSubmit = hooks.useFormFunction('requestSubmit')

  const handleSubmit = useCallback(() => requestSubmit({ force_duplicate_order: true, force_options: true }), [requestSubmit])

  const mergedProps = {
    handleSubmit,
  }

  return <Component {...mergedProps} />
}

export default Container
